import eventBus from "../events/eventBus";
import { showAlert } from "./alerts";

const toolTip = `<span class="italic">(${t('translations.translated')})</span>`;

function showLanguage(textObj, elementId, originalBtn, translatedBtn) {
    const reviewText = document.getElementById(elementId);

    if (!elementId || reviewText == null) {
        console.error("Element ID is required to show language.");
        return false;
    }

    if (textObj.original) {
        originalBtn.classList.add('hidden');
        translatedBtn.classList.remove('hidden');
        
        reviewText.innerHTML = getFirstAvailableTranslation(textObj);

        if (textObj.original == locale) {
            translatedBtn.classList.add('hidden');
            return false;
        }

        return true;
    } else {
        originalBtn.classList.add('hidden');
        translatedBtn.classList.add('hidden');
        getFirstAvailableTranslation(textObj);
        return false;
    }
}

function getFirstAvailableTranslation(textObj) {
    if (textObj.original && textObj[textObj.original]) {
        return textObj[textObj.original];
    } else if (textObj[locale]) {
        return textObj[locale];
    } else if (textObj.en) {
        return textObj.en;
    } else if (textObj.de) {
        return textObj.de;
    } else if (textObj.tr) {
        return textObj.tr;
    } else if (Object.keys(textObj).length > 0) {
        if (Object.keys(textObj).length == 1 && Object.keys(textObj)[0] == 'original') {
            return t('translations.noTranslation');
        }
        if (Object.keys(textObj)[0] == 'original') {
            return textObj[Object.keys(textObj)[1]];
        }
    }

    return t('translations.noTranslation');
}

export function setupTranslator(textObj, elementId, config = {
    showNotice: true,
    showBtn: true,
} ) {
    const reviewText = document.getElementById(elementId);
    if (!elementId || reviewText == null) {
        console.error("Element ID is required to setup translator.");
        return;
    }

    const container = document.createElement('div');
    const parent = reviewText.parentElement;

    if (!parent) {
        console.error("Parent element not found.");
        return;
    }

    const originalBtn = document.createElement('div');
    originalBtn.className = 'flex justify-between';
    originalBtn.innerHTML = config.showBtn? `
        <a class="link link-primary"><i class="fa-solid fa-language mr-2"></i>${t('translations.viewOriginal')}</a>
        ${config.showNotice ? `<a href="/faq#translations" class="link link-primary"><i class="fa-solid fa-circle-info mr-2"></i>${t('translations.learnMore')}</a>` : ''}
        ` : '';
    container.appendChild(originalBtn);
    const translatedBtn = document.createElement('div');
    translatedBtn.innerHTML = config.showBtn? `
        <a class="link link-primary"><i class="fa-solid fa-language mr-2"></i>${t('translations.translate')}</a>
    ` : '';
    if (config.showBtn === true) {
        originalBtn.onclick = () => {
            switchToOriginalText(textObj, elementId, originalBtn, translatedBtn);
        }
        translatedBtn.onclick = () => {
            switchToTranslatedText(textObj, elementId, originalBtn, translatedBtn);
        }
    } else {
        container.className = 'hidden';
    }
    container.appendChild(translatedBtn);
    parent.insertBefore(container, reviewText.nextSibling);
    eventBus.emit('translation:setup', { elementId });

    return { btnShown: showLanguage(textObj, elementId, originalBtn, translatedBtn), originalBtn, translatedBtn };
}

export function switchToOriginalText(textObj, elementId, originalBtn, translatedBtn) {
    const reviewText = document.getElementById(elementId);

    if (!elementId || reviewText == null) {
        console.error("Element ID is required to switch text.");
        return;
    }

    if (textObj.original && textObj.original != locale && textObj[textObj.original]) {
        reviewText.innerHTML = textObj[textObj.original];
        originalBtn.classList.add('hidden');
        translatedBtn.classList.remove('hidden');
    }

    eventBus.emit('translation:switched', { to: 'original', elementId });
}

export function switchToTranslatedText(textObj, elementId, originalBtn, translatedBtn) {
    const reviewText = document.getElementById(elementId);

    if (!elementId || reviewText == null) {
        console.error("Element ID is required to switch text.");
        return;
    }

    if (textObj.original && textObj.original != locale && textObj[locale]) {
        reviewText.innerHTML = textObj[locale] + toolTip;
        translatedBtn.classList.add('hidden');
        originalBtn.classList.remove('hidden');
    } else {
        showAlert(t('translations.noTranslation'), "info");
    }
    eventBus.emit('translation:switched', { to: 'translated', elementId });
}